"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import { usePathname } from "next/navigation"
import { rastreamentoBloqueado } from "@/lib/utils/tracking-routes"

/**
 * Scripts de rastreamento do WellTrainer: Google Tag Manager (que carrega GA4,
 * Clarity, Meta Pixel 1231086455843649, Google Ads AW-18011818139 e Consent
 * Mode) e o pixel do ChatGPT (OpenAI Bazaar, `oaiq`).
 *
 * A UTMify saiu em 02/09/2026 (pixel e script de UTMs). A captura de UTM que
 * vale hoje é a nossa, em `lib/utm.ts` + `/go`; as funções que limpavam o
 * `utm_source` que ela sujava continuam lá, porque link antigo ainda circula.
 *
 * Carregam nas páginas do funil do WellTrainer e em mais lugar nenhum: fora
 * ficam as páginas externas do personal, a área logada de uso do produto, a
 * porta do aluno e **todo aparelho com conta de aluno aberta** (quem responde
 * é `rastreamentoBloqueado`). Também ficam desabilitados em desenvolvimento.
 *
 * A decisão espera o primeiro efeito porque parte dela depende do
 * `localStorage`, que não existe no servidor: decidir no corpo faria o HTML do
 * servidor e o do navegador discordarem. O atraso é de um quadro, e os dois
 * scripts já eram `afterInteractive`.
 */
export function WtTrackingScripts() {
  const pathname = usePathname()
  const [podeCarregar, setPodeCarregar] = useState(false)

  useEffect(() => {
    setPodeCarregar(!rastreamentoBloqueado(pathname))
  }, [pathname])

  if (process.env.NODE_ENV === "development") return null
  if (!podeCarregar) return null

  return (
    <>
      {/* Google Tag Manager, carrega GA4, Clarity e Consent Mode via GTM */}
      {/* Meta Pixel (1231086455843649) e Google Ads (AW-18011818139) também via GTM */}
      <Script
        id="gtm-head"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-N4GFPF48');`,
        }}
      />
      {/* Pixel do ChatGPT (OpenAI) — o snippet cria o stub `window.oaiq` com fila
          própria, então eventos disparados antes do SDK carregar não se perdem.
          Os eventos saem via `medirPixelOpenAI` no tracking-service (não pelo GTM). */}
      <Script
        id="openai-pixel"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `!function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","https://bzrcdn.openai.com/sdk/oaiq.min.js");oaiq("init",{pixelId:"VdQrcjb8Ef5V9PV4ud7XUu"});`,
        }}
      />
      {/* Google Tag Manager (noscript) */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-N4GFPF48"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
    </>
  )
}
